var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_In_Progress",
    "data-name": "Icon - In Progress",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M17.5,0A17.5,17.5,0,1,1,0,17.5,17.5,17.5,0,0,1,17.5,0Z",
    fill: "#ffab48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "emoji_objects_FILL0_wght400_GRAD0_opsz24",
    d: "M196.525-862a2.027,2.027,0,0,1-1.058-.281,2.046,2.046,0,0,1-.742-.754,1.733,1.733,0,0,1-1.271-.529,1.733,1.733,0,0,1-.529-1.271v-3.195a6.52,6.52,0,0,1-2.126-2.318,6.342,6.342,0,0,1-.8-3.127,6.294,6.294,0,0,1,1.9-4.624,6.294,6.294,0,0,1,4.624-1.9,6.294,6.294,0,0,1,4.624,1.9,6.294,6.294,0,0,1,1.9,4.624,6.305,6.305,0,0,1-.8,3.15,6.578,6.578,0,0,1-2.126,2.3v3.195a1.733,1.733,0,0,1-.529,1.271,1.733,1.733,0,0,1-1.271.529,2.046,2.046,0,0,1-.742.754A2.028,2.028,0,0,1,196.525-862Zm-1.8-2.835h3.6v-.81h-3.6Zm0-1.71h3.6v-.855h-3.6Zm-.18-2.655h1.305v-2.43l-1.98-1.98.945-.945,1.71,1.71,1.71-1.71.945.945-1.98,1.98v2.43h1.3a4.927,4.927,0,0,0,1.98-1.721,4.469,4.469,0,0,0,.765-2.554,4.561,4.561,0,0,0-1.373-3.353,4.561,4.561,0,0,0-3.352-1.373,4.561,4.561,0,0,0-3.353,1.373,4.561,4.561,0,0,0-1.372,3.353,4.469,4.469,0,0,0,.765,2.554A4.927,4.927,0,0,0,194.545-869.2ZM196.525-872.845ZM196.525-873.7Z",
    transform: "translate(-179 889)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/Icon3.0c51031d1e1be94221822440616cc1d9.svg";
export { ForwardRef as ReactComponent };